// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"f30a2936","80":"e4fc1700","165":"4cb7be34","227":"7a14b78b","326":"5e295096","367":"1e52e05c","371":"647c3730","508":"8865c24d","555":"3aeaf88c","570":"4a272202","843":"953739eb"}[chunkId] + ".chunk.js";
};